import React from "react";
import {reportesResources} from "../endpoints";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {Checkbox, Divider, FormGroup} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import NumberFormat from "react-number-format";
import useToken from "../useToken";
import {Autocomplete} from "@material-ui/lab";

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            prefix=""
        />
    );
}

class DialogExportar extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            open : true,
            reportes: [],
            copias: 1,
            formato_elegidos:[],
            cliente:null,
            valor: 15,
            mes: ""
        }
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value.trim()});
    }

    reportesDisponibles = () =>{
        reportesResources.getReportesDisponibles().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then( data => {
            this.setState({reportes:data})
            data.forEach(
                element => {
                    this.setState({[element.nombre]:element.valor})
                    if(element.valor === true){
                        let formatos = this.state.formato_elegidos;
                        this.setState({formato_elegidos:formatos.concat(element.nombre)})
                    }
                }
            )
        }).catch(error=> {
            console.error(error);
        });
    }

    handleChangeCheck = (event) => {
        this.setState({[event.target.name]: event.target.checked});
        if(!event.target.checked){
            var array = [...this.state.formato_elegidos]; // make a separate copy of the array
            var index = array.indexOf(event.target.name)
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({formato_elegidos: array});
            }
        }
        else{
            if(event.target.name === 'Excel'){
                this.setState({formato_elegidos: this.state.formato_elegidos.concat('Xlsx')})
            }
            else{
                this.setState({formato_elegidos: this.state.formato_elegidos.concat(event.target.name)})
            }
        }
    }

    UNSAFE_componentWillMount() {
        if (this.props.reporte !== 'consolidado_auditoria_visual' && this.props.reporte !== 'consolidado_auditoria_altillo' && this.props.reporte !== 'consolidado_validaciones' )  {
            this.reportesDisponibles()
        }
        else{
            this.setState({
                reportes:[{nombre: 'Pdf', valor: true},{nombre: 'Xlsx', valor: false}, {nombre: 'Csv', valor: false}]
            })
        }
        let datos_inv = useToken.getDatos()
        this.setState({cliente:datos_inv.app})
    }


    exportar = () =>{
        if(this.props.reporte !== "variance" && this.props.reporte !== "variance_walmart"  && this.props.reporte !== "variance_smu"){
            let params
            this.setState({progress: true})
            if( this.props.reporte === "high_dollar_smu" || this.props.reporte === 'high_dollar_bodega_smu' ||  this.props.reporte === "low_dollar_smu" || this.props.reporte === 'low_dollar_bodega_smu'){
                params = this.state.valor
            }
            else if ( this.props.reporte === 'consolidado_auditoria_altillo' ||  this.props.reporte === 'consolidado_auditoria_visual' || this.props.reporte === 'consolidado_validaciones'){
                if (this.state.mes) {
                    const [anio, mes] = this.state.mes.split("-")

                    let inicio = `${anio}-${mes}-01`

                    const ultimoDia = String(new Date(anio, mes, 0).getDate()).padStart(2,"0")

                    let termino = `${anio}-${mes}-${ultimoDia}`

                    params = inicio + ',' + termino
                }               
            }
            else{
                params = this.props.params
            }
            let datosExportar = {
                reporte: this.props.reporte,
                params: params,
                copias: this.state.copias,
                formatos_exportar: this.state.formato_elegidos,
                origen: this.props.origen
            }
            reportesResources.enviarDatosReportes(datosExportar).then(async response => {
                if (response) {
                    return await response.json()
                }
            }).then( result => {
                if(result.message){
                    this.setState({progress:false})
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.error(error);
                this.setState({progress:false})
                this.props.refrescar("Ha ocurrido un error inesperado","error")

            });
        }
        else{
            this.setState({progress: true})
            const seleccionados = this.props.params

            if (this.props.reporte === "variance" || this.props.reporte === "variance_smu") {
                const verificados  = this.verificarSeleccionados(seleccionados);
                if (verificados.length === 0) {
                    this.props.refrescar("No hay datos con valores para exportar", "error")
                } else {
                    for (let i = 0; i < verificados.length; i++) {
                        let tipo_filtro = null;
                        if (verificados[i].filtro.toString() === '1') {
                            tipo_filtro = "monto"
                        } else if (verificados[i].filtro.toString() === '2') {
                            tipo_filtro = "top"
                        } else {
                            tipo_filtro = "top_porcentual"
                        }

                        let datosExportar2 = {
                            reporte: this.props.reporte,
                            params: "id_jerarquia=" + verificados[i].id + ",valor=" + verificados[i].cantidad + ",tipo_filtro=" + tipo_filtro,
                            copias: this.state.copias,
                            formatos_exportar: this.state.formato_elegidos,
                            origen: this.props.origen
                        }
                        reportesResources.enviarDatosReportes(datosExportar2).then(async response => {
                            if (response) {
                                return await response.json()
                            }
                        }).then(result => {
                            if (result.message) {
                                this.setState({progress: false})
                                this.props.refrescar(result.message, result.severity)
                            } else {
                                throw new Error('Something went wrong ...');
                            }
                        }).catch(error => {
                            console.error(error);
                            this.setState({progress: false})
                            this.props.refrescar("Ha ocurrido un error inesperado", "error")

                        });
                    }
                }
            }
            else{
                const verificados  = this.verificarSeleccionadosWalmart(seleccionados);
                for (let i = 0; i < verificados.length; i++) {
                    let datosExportar = {
                        reporte: this.props.reporte,
                        params: "id_jerarquia=" + verificados[i].id,
                        copias: this.state.copias,
                        formatos_exportar: this.state.formato_elegidos,
                        origen: this.props.origen
                    }
                    reportesResources.enviarDatosReportes(datosExportar).then(async response => {
                        if (response) {
                            return await response.json()
                        }
                    }).then(result => {
                        if (result.message) {
                            this.setState({progress: false})
                            this.props.refrescar(result.message, result.severity)
                        } else {
                            throw new Error('Something went wrong ...');
                        }
                    }).catch(error => {
                        console.error(error);
                        this.setState({progress: false})
                        this.props.refrescar("Ha ocurrido un error inesperado", "error")

                    });
                }
            }

        }

    }

    verificarSeleccionados = (list) =>{
        const verificados = []
        for (let i = 0; i < list.length; i++){
            if (list[i].cantidad !== "-----------"){
                verificados.push(list[i])
            }
        }
        return verificados;
    }

    verificarSeleccionadosWalmart = (list) =>{
        const verificados = []
        for (let i = 0; i < list.length; i++){
            verificados.push(list[i])
        }
        return verificados;
    }

    generarMeses = () => {
        const meses = []

        const inicio = new Date(2025, 9, 1) // octubre 2025
        const fin = new Date() // mes actual

        const fecha = new Date(inicio)

        while (fecha <= fin) {

            const label = fecha.toLocaleString("es-ES", {
                month: "long",
                year: "numeric"
            }).toUpperCase()

            const value = `${fecha.getFullYear()}-${String(fecha.getMonth()+1).padStart(2,"0")}`

            meses.push({
                label,
                value
            })

            fecha.setMonth(fecha.getMonth() + 1)
        }

        return meses
    }

    render() {
        return(
            <Dialog
                open={this.state.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Opciones disponibles</DialogTitle>
                <DialogContent style={{display:'inline-grid'}}>
                    <FormGroup>
                        {this.state.reportes.map((reporte)=>{
                            if(reporte.nombre === "Xlsx"){
                                return <FormControlLabel
                                    key={reporte.nombre}
                                    control={<Checkbox checked={this.state[reporte.nombre] || false} onChange={this.handleChangeCheck} name={reporte.nombre} />}
                                    label={"Excel"}
                                />
                            }
                            else{
                                return <FormControlLabel
                                    key={reporte.nombre}
                                    control={<Checkbox checked={this.state[reporte.nombre] || false} onChange={this.handleChangeCheck} name={reporte.nombre} />}
                                    label={reporte.nombre}
                                />
                            }
                        })}
                    </FormGroup>
                    <Divider/>
                    <Typography style={{marginLeft:'10px', marginRight: '7px', marginTop: '10px'}} variant={'h6'}>Copias:</Typography>
                    <div style={{display:'flex', marginTop:'10px', marginBottom:'10px'}}>
                       <TextField
                            onChange={this.handleChange}
                            value={this.state.copias}
                            name="copias"
                            variant="outlined"
                            margin={'dense'}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                        />
                    </div>
                    {this.state.cliente === 'smu' && (this.props.reporte === 'high_dollar_smu' ||this.props.reporte === 'high_dollar_bodega_smu' ||  this.props.reporte === "low_dollar_smu" || this.props.reporte === 'low_dollar_bodega_smu' )?
                        <div>
                            <Typography style={{marginLeft:'10px', marginRight: '7px', marginTop: '10px'}} variant={'h6'}>Top:</Typography>
                            <div style={{display:'flex', marginTop:'10px', marginBottom:'10px'}}>
                                <TextField
                                    onChange={this.handleChange}
                                    value={this.state.valor}
                                    name="valor"
                                    variant="outlined"
                                    margin={'dense'}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                />
                            </div>
                        </div>: null}

                    {this.props.reporte === 'consolidado_auditoria_visual' ||this.props.reporte === 'consolidado_auditoria_altillo'  ||this.props.reporte === 'consolidado_validaciones'  ?
                        <div style={{marginLeft:'10px', marginRight:'7px', marginTop:'10px'}} >
                            <Typography variant={'h6'}>
                                Mes:
                            </Typography>
                            <Autocomplete
                                size="small"
                                options={this.generarMeses()}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.label}
                                onChange={(event, newValue) => {
                                    if(newValue === null){
                                        this.setState({mes:''})
                                    }
                                    else{
                                        this.setState({mes:newValue.value})
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                        label="Mes"
                                        placeholder="Seleccione mes"
                                    />
                                )}
                            />
                        </div>: null}
                    {this.state.progress? <CircularProgress style={{marginTop: '10px',justifySelf: 'center'}}/>: null}

                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    {this.props.reporte === 'consolidado_auditoria_visual' ||this.props.reporte === 'consolidado_auditoria_altillo'  ||this.props.reporte === 'consolidado_validaciones'  ?
                        <Button disabled={this.state.formato_elegidos.length === 0 || this.state.mes === ''} onClick={this.exportar} variant="contained" color="primary" >
                            Exportar
                        </Button> :
                        <Button disabled={this.state.formato_elegidos.length === 0} onClick={this.exportar} variant="contained" color="primary" >
                            Exportar
                        </Button>}
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogExportar;